import { InvestorKycFiles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepTabs/utils/getInvestorKycFiles';
import { KycApprovalStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import {
	AcceptanceStatus,
	GetKYCInvestorInstanceRes,
	KYCFileType,
} from '@dealstack/shared/lib/generated';

type getKycNestedStatusProps = {
	currentInvestor?: GetKYCInvestorInstanceRes;
	investorKycFiles?: InvestorKycFiles;
	type: Exclude<KYCFileType, KYCFileType.OTHER>;
};

export const getKycStatusByFileType = ({
	currentInvestor,
	investorKycFiles,
	type,
}: getKycNestedStatusProps): KycApprovalStatus => {
	const kycFilesByType = investorKycFiles?.[type] ?? [];
	const isRequestedMorePivDocs = currentInvestor?.processSettings?.areMorePivDocsRequested;

	if (type === 'INVESTMENT_VEHICLE' && isRequestedMorePivDocs) {
		return 'WAITING';
	}
	if (!kycFilesByType.length) {
		return null;
	}
	const someAreRejected = kycFilesByType.some(
		(kycFile) =>
			kycFile.status === AcceptanceStatus.REJECTED ||
			kycFile.status === AcceptanceStatus.REREQUESTED
	);
	if (someAreRejected) {
		return AcceptanceStatus.REJECTED;
	}
	const allAreAccepted = kycFilesByType.every(
		(kycFile) => kycFile.status === AcceptanceStatus.APPROVED
	);
	if (allAreAccepted) {
		return AcceptanceStatus.APPROVED;
	}
	return AcceptanceStatus.PENDING;
};
